import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CuiButtonComponent } from '@idealink-material/ui-core';
import { CuiIconComponent } from '@idealink-material/ui-icons';

@Component({
    selector: 'app-forbidden',
    standalone: true,
    imports: [RouterModule, CuiButtonComponent, CuiIconComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <div class="flex items-center justify-center min-h-screen overflow-hidden p-6" style="background: var(--bg-page)">
            <div class="flex flex-col items-center justify-center w-full max-w-lg rounded-2xl p-10" style="background: var(--bg-card); box-shadow: var(--shadow-card)">
                <span class="font-bold text-3xl" style="color: var(--dash-primary)">403</span>
                <h1 class="font-bold text-3xl lg:text-4xl mb-2" style="color: var(--text-primary)">Forbidden</h1>
                <div class="text-center mb-8" style="color: var(--text-muted)">You don&rsquo;t have access to this page or action. If you think this is a mistake, please contact your administrator.</div>

                <a routerLink="/" class="w-full flex items-center py-6" style="border-bottom: 1px solid var(--border-default)">
                    <span class="flex justify-center items-center rounded-full" style="height: 3.5rem; width: 3.5rem; border: 2px solid var(--dash-primary); color: var(--dash-primary)">
                        <cui-icon name="table_chart" size="md" color="var(--dash-primary)" />
                    </span>
                    <span class="ml-6 flex flex-col">
                        <span class="lg:text-xl font-medium mb-0 block" style="color: var(--text-primary)">Frequently Asked Questions</span>
                        <span class="lg:text-base" style="color: var(--text-muted)">Ultricies mi quis hendrerit dolor.</span>
                    </span>
                </a>
                <a routerLink="/" class="w-full flex items-center py-6" style="border-bottom: 1px solid var(--border-default)">
                    <span class="flex justify-center items-center rounded-full" style="height: 3.5rem; width: 3.5rem; border: 2px solid var(--dash-primary); color: var(--dash-primary)">
                        <cui-icon name="help" size="md" color="var(--dash-primary)" />
                    </span>
                    <span class="ml-6 flex flex-col">
                        <span class="lg:text-xl font-medium mb-0" style="color: var(--text-primary)">Solution Center</span>
                        <span class="lg:text-base" style="color: var(--text-muted)">Phasellus faucibus scelerisque eleifend.</span>
                    </span>
                </a>
                <a routerLink="/" class="w-full flex items-center mb-8 py-6" style="border-bottom: 1px solid var(--border-default)">
                    <span class="flex justify-center items-center rounded-full" style="height: 3.5rem; width: 3.5rem; border: 2px solid var(--dash-primary); color: var(--dash-primary)">
                        <cui-icon name="lock_open" size="md" color="var(--dash-primary)" />
                    </span>
                    <span class="ml-6 flex flex-col">
                        <span class="lg:text-xl font-medium mb-0" style="color: var(--text-primary)">Permission Manager</span>
                        <span class="lg:text-base" style="color: var(--text-muted)">Accumsan in nisl nisi scelerisque</span>
                    </span>
                </a>

                <a routerLink="/dashboard" class="w-full">
                    <p-button [fullWidth]="true">Go to Dashboard</p-button>
                </a>
            </div>
        </div>
    `
})
export class Forbidden {}
